import React from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Fab from '../Fab';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    top: 16,
    left: -20,
    border: `1px solid ${theme.palette.grey[600]}`
  },
  absolute: {
    position: 'absolute'
  },
  floating: {
    top: -16,
    left: 'calc(100% - 20px)'
  },
  icon: {
    fontSize: '32px'
  }
}));

export interface ModalCloseButtonProps {
  floatingModal?: boolean;
  onClick: (event: object) => void;
  styles?: any;
  tabIndex: number;
}

const ModalCloseButton = ({ styles = {}, ...props }: ModalCloseButtonProps): React.ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation('ModalCloseButton');

  return (
    <Fab
      aria-label={t('Close Modal Button')}
      className={cx(classes.root, props.floatingModal ? classes.floating : classes.absolute)}
      color="secondary"
      startIcon={<CloseIcon className={classes.icon} />}
      style={styles}
      variant="outlined"
      {...props}
    >
      <span />
    </Fab>
  );
};

export default ModalCloseButton;
